import React from 'react';
import { Link } from 'react-router-dom'

import Spinner from 'components/shared/Spinner';
import KitPanelStats from 'components/kits/overview/KitPanelStats';


class KitPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const kit = this.props.data.kit;
    const orders = this.props.data.orders;

    return (
      <div className="card" style={{margin: '1.5rem 0 2rem 0'}}>
        <div className="card-header py-2">
          <div className="row">
            <div className="col-9">

              <h3 className="card-title mt-0 mb-0">
                {kit.name}

                <span style={{position: 'relative', top: '-0.25rem', marginLeft: '0.45rem', color: '#666', fontSize: '16px'}}>
                  (A.S. {kit.schoolyear + '/' + (parseInt(String(kit.schoolyear).substring(2, 4))+1)})
                </span>

                {/* <span style={{fontSize: '16px'}} className={'ml-2 badge ' + (kit.schoolyear == (new Date).getFullYear() ? 'badge-primary' : 'badge-secondary')}>
                 {kit.schoolyear + '/' + (parseInt(String(kit.schoolyear).substring(2, 4))+1)}
                </span> */}
              </h3>
              {/* {
                kit.subtitle ? <h4 className="card-title text-secondary mt-0 mb-0">{kit.subtitle}</h4> : ''
              } */}
            </div>
            <div className="col-3 text-right">
              <div style={{position: 'relative', top: '50%', transform: 'translateY(-50%)'}}>
                <Link to={'/kits/' + kit.id + '/edit/'} className="btn btn-sm btn-secondary">
                  <i className="fa fa-edit" /> modifica kit
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row mb-2">
            <div className="col-9">
              <h4>
                <i className="fa fa-shopping-cart" /> Ordini
                {/* <span style={{zoom: 0.65, marginLeft: '0.5rem'}}>
                  {
                    this.props.problems ? (
                      this.props.problems.num_problems > 0 ? (
                        <a href="javascript:void(0);" className="text-danger" data-goto={"/kit-orders/" + kit.id + "/problems/"} onClick={this.handleClick}>
                          <i className="fa fa-exclamation-triangle" /> {this.props.problems.num_problems} problemi ({this.props.problems.num_kits} kit / {this.props.problems.num_students} alunni)
                        </a>
                      ) : ""
                    ) : (
                      this.props.problems !== undefined ? <Spinner message="Controllo problemi..." /> : ''
                    )
                  }
                </span> */}
              </h4>
            </div>
            <div className="col-3 text-right">
              <div style={{position: 'relative', top: '50%', transform: 'translateY(-50%)'}}>
                <Link to={'/kit-orders/' + kit.id + '/overview/'}>
                  vai agli ordini <i className="fa fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <KitPanelStats title="Oggi" data={orders.today} />
            </div>
            <div className="col-3">
              <KitPanelStats title="Ultimi 3 giorni" data={orders.last_3_days} />
            </div>
            <div className="col-3">
              <KitPanelStats title="Ultima settimana" data={orders.last_7_days} />
            </div>
            <div className="col-3" style={{borderLeft: "1px solid #aaa"}}>
              <KitPanelStats title="Totale" data={orders.all_time} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default KitPanel;


// WEBPACK FOOTER //
// ./src/components/kits/overview/KitPanel.js